import "./IconContainer.scss"
import { classNames } from "../../helpers/cssClassHelper"

export interface IconContainerProps {
    size?: "small" | "normal"
    color?: string
    children?: React.ReactNode
}

export default function IconContainer(props: IconContainerProps) {
    const containerClass = classNames(
        "icon-container",
        props.size ?? "normal",
    )

    const iconClass = classNames("material-symbols-outlined", "icon")

    const iconColor = props.color ?? ''

    return <div className={containerClass}>
        <span className={iconClass} style={{ color: iconColor }}>
            {props.children}
        </span>
    </div>
}
